import { render, staticRenderFns } from "./ResultsScale.vue?vue&type=template&id=5e9e0ce2&"
import script from "./ResultsScale.vue?vue&type=script&lang=js&"
export * from "./ResultsScale.vue?vue&type=script&lang=js&"
import style0 from "./ResultsScale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
